import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=72e25f84&scoped=true&"
var script = {}
import style0 from "./FormLayout.vue?vue&type=style&index=0&id=72e25f84&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e25f84",
  null
  
)

export default component.exports